import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    const params = new URLSearchParams(window.location.search);
    const role = params.get("role") || "customer";

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(`/auth/google/session?role=${encodeURIComponent(role)}`, {
          session_id: sessionId,
        });
        setUser(data.user);
        const dest = data.user.role === "merchant" ? "/merchant" : "/customer";
        // Clear hash from URL
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-4xl gold-text">y ℶα</div>
        <div className="text-secondary-fg text-sm mt-4 tracking-widest uppercase">Verifying…</div>
      </div>
    </main>
  );
}
